import { type AgGrid } from "@jsq/ds/core";
import { Colors } from "@jsq/ds/styles";
import type { GroupedEntityRow } from "./allClientEntitiesDataSource";

export const getRowStyle = (
  params: AgGrid.RowClassParams<GroupedEntityRow>,
): { backgroundColor: string } | undefined => {
  if (params.data?.hasWarning) {
    return { backgroundColor: Colors.Warning200 };
  }
  return undefined;
};

export const getRowId = (params: AgGrid.GetRowIdParams<GroupedEntityRow>): string => {
  const data = params.data;
  if (!data) return "";

  if (data.type === "client") {
    return `client-${data.clientId}`;
  } else if (data.type === "billingGroup") {
    return `bg-${data.clientId}-${data.billingGroupId}`;
  } else {
    return `entity-${data.entityId}`;
  }
};

export const isServerSideGroup = (dataItem: GroupedEntityRow): boolean => {
  return dataItem.type !== "entity" && dataItem.childCount > 0;
};
